<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 105 105" :class="{'yellow': iconColour == 'yellow'}">
        <path d="M102.9,54.24H2.1a1.74,1.74,0,0,1,0-3.48H102.9a1.74,1.74,0,0,1,0,3.48Z" />
        <path d="M68.14,89a1.74,1.74,0,0,1-1.23-3L100.44,52.5,66.91,19a1.74,1.74,0,0,1,2.46-2.46l34.76,34.76a1.74,1.74,0,0,1,0,2.46L69.37,88.49A1.73,1.73,0,0,1,68.14,89Z"/>
    </svg>
</template>

<style lang="scss" scoped>
path {
    fill: $colour__primary1;
    .yellow & {
        fill: $colour__accent1;
    }
}
</style>

<script>
export default {
    name: 'ArrowIcon',
    props: ['iconColour']
}
</script>
